import { render, staticRenderFns } from "./modal-edit-order.vue?vue&type=template&id=75647cb7&"
import script from "./modal-edit-order.vue?vue&type=script&lang=js&"
export * from "./modal-edit-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports